<template>
  <div class="Container">
    <span v-if="label" class="Label">{{ label }}</span>
    <div :class="containerClasses" @click="$emit('input', !value)">
      <div v-if="disabled" class="Overlay" @click.stop />
      <div :class="knobClasses" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VvSwitch',
  props: {
    value: Boolean,
    label: String,
    disabled: Boolean
  },
  computed: {
    containerClasses() {
      return this.value ? ['Switch-Container', 'Active'] : 'Switch-Container'
    },
    knobClasses() {
      return this.value ? ['Knob', 'Active'] : 'Knob'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Container {
  display: flex;
  flex-direction: row;
  align-items: center;

  .Label {
    margin-right: 15px;
  }

  .Switch-Container {
    cursor: pointer;
    position: relative;
    z-index: 2;
    height: 24px;
    width: 44px;
    background-color: #c7c7c7;
    border-radius: 12px;
    transition: all 150ms linear;
    overflow: hidden;

    &.Active {
      background-color: $primary;
    }

    .Overlay {
      position: absolute;
      z-index: 5;
      background-color: white;
      opacity: 0.5;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    .Knob {
      position: absolute;
      height: 20px;
      width: 20px;
      border-radius: 20px;
      top: 2px;
      left: 2px;
      background-color: white;
      transition: all 150ms linear;

      &.Active {
        transform: translateX(20px);
      }
    }
  }
}
</style>
